<div *ngIf="name">
    <fa-icon *ngIf="!!icon" [icon]="faFlag"></fa-icon> {{ name }}
</div>